const testimonials = [
  {
    name: "Sarah & David K.",
    location: "Thornton, CO — Reunion neighborhood",
    rating: 5,
    text: "Booked a last-minute spring break trip to Cancun and realized our daughter's passport expired two years ago. Called Fast Passport Center on a Monday, shipped documents Tuesday, had the passport Friday afternoon. Made our Saturday flight out of DIA without a single problem. They walked us through every step and were incredibly patient with our questions. Cannot thank them enough.",
    service: "Emergency Passport Renewal",
  },
  {
    name: "Marcus T.",
    location: "Thornton, CO — Eastlake area",
    rating: 5,
    text: "Tech consultant here — I got short notice for a client project in Germany and my passport had two months left on it. Germany requires six months validity. Fast Passport Center handled my renewal in four business days. I made my Frankfurt flight on time. Professional, fast, and worth every cent. Way better than standing in line at the passport agency in Aurora.",
    service: "Expedited Passport Renewal",
  },
  {
    name: "The Reyes Family",
    location: "Northglenn, CO",
    rating: 5,
    text: "Planning a ski trip to Whistler BC and found out three of our four family members had expired passports — Canada requires valid passports. Fast Passport Center handled all three renewals simultaneously and got them back to us in eight business days. The family trip was saved. They made a stressful situation feel completely manageable.",
    service: "Family Expedited Renewals",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function TestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Thornton &amp; North Denver Metro Travelers Say About Our Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Thornton, Northglenn, and Westminster travelers who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}